export default "__VITE_PUBLIC_ASSET__946d2b72__"